import axios from 'axios';
import { createCloudRunAxios } from './axios';

const remiApi = createCloudRunAxios('remi-api');

export const testCall = async ({
  contactId,
  flowId,
  organizationId,
  reasonForCall,
}: {
  contactId: string;
  flowId: string;
  organizationId: string;
  reasonForCall?: string;
}) => {
  try {
    const response = await remiApi.post('/api/v1/flows/test-call', {
      contact_id: contactId,
      flow_id: flowId,
      organization_id: organizationId,
      reason_for_call: reasonForCall,
    });
    return response.data;
  } catch (error) {
    console.error('Error testing call:', error);
    if (axios.isAxiosError(error)) {
      const detail = error.response?.data?.detail ?? error.response?.data?.error ?? error.response?.data?.message;
      if (typeof detail === 'string' && detail.trim()) {
        throw new Error(detail.trim());
      }
      if (detail) {
        throw new Error(JSON.stringify(detail));
      }
      if (error.message) {
        throw new Error(error.message);
      }
    }
    throw error;
  }
};
